"use client";
import { jsxs as r, jsx as e } from "react/jsx-runtime";
import S from "clsx";
import b from "next/image";
import { memo as B, useState as l, useRef as I, useMemo as T } from "react";
import { Button as L } from "../../../buttons/button/Button.js";
import { Box as p, PaginationDot as j } from "../../base/Base.js";
import '../../../assets/PlateImageCurtain.css';const z = "_plate_t383v_1", E = "_text_t383v_27", V = "_white_t383v_34", U = "_violet_t383v_39", W = "_orange_t383v_44", q = "_gray_t383v_49", A = "_red_t383v_54", F = "_notice_t383v_59", G = "_images_t383v_65", H = "_image1_t383v_69", J = "_image2_t383v_77", K = "_drag_icon_t383v_89", O = "_line_t383v_109", Q = "_pagination_t383v_131", t = {
  plate: z,
  text: E,
  white: V,
  violet: U,
  orange: W,
  gray: q,
  red: A,
  notice: F,
  images: G,
  image1: H,
  image2: J,
  drag_icon: K,
  line: O,
  pagination: Q
}, Y = B(
  ({ text: P, color: v, compare: o, className: C, placeText: g = "top", ...X }) => {
    var y;
    const [i, _] = l(0), u = I(null), f = ((y = u.current) == null ? void 0 : y.getBoundingClientRect().width) || 0, [w, x] = l(0), [a, m] = l(!1), [c, d] = l(0), D = (n) => {
      x(n.clientX), m(!0);
    }, R = (n) => {
      const s = n.clientX - w;
      d(a ? s : 0);
    }, $ = (n) => {
      x(n.changedTouches[0].clientX), m(!0);
    }, k = (n) => {
      const s = n.changedTouches[0].clientX - w;
      d(a ? s : 0);
    }, h = () => {
      d(0), m(!1);
    }, M = T(
      () => c / (f / 100) + 50,
      [f, c]
    ), N = /* @__PURE__ */ r("div", { className: t.images, ref: u, children: [
      /* @__PURE__ */ e(
        "div",
        {
          className: t.line,
          style: {
            transform: `translateX(${c}px)`,
            transition: a ? "0s" : "1s"
          },
          onMouseDown: D,
          onMouseMove: R,
          onMouseUp: h,
          onMouseLeave: h,
          onTouchStart: $,
          onTouchMove: k,
          onTouchEnd: h
        }
      ),
      /* @__PURE__ */ e(
        "div",
        {
          className: t.drag_icon,
          style: {
            transform: `translateX(${c}px)`,
            transition: a ? "0s" : "1s"
          },
          children: /* @__PURE__ */ e("span", { className: "material-icons", "data-icon": "unfold_more" })
        }
      ),
      /* @__PURE__ */ e(
        b,
        {
          className: t.image1,
          src: o[i].before,
          alt: "",
          placeholder: "blur"
        }
      ),
      /* @__PURE__ */ e(
        b,
        {
          className: t.image2,
          src: o[i].after,
          alt: "",
          placeholder: "blur",
          style: {
            clipPath: `polygon(100% 0%, ${M}% 0%, ${M}% 100%, 100% 100%)`,
            transition: a ? "0s" : "1s"
          }
        }
      ),
      o.length > 1 && /* @__PURE__ */ e(p, { gap: 4, row: !0, className: t.pagination, children: o.map((n, s) => /* @__PURE__ */ e(
        j,
        {
          active: s === i,
          onClick: () => _(s)
        },
        s
      )) })
    ] });
    return /* @__PURE__ */ r(
      "div",
      {
        className: S(t.plate, t[g], C),
        ...X,
        children: [
          g === "bottom" && N,
          /* @__PURE__ */ r(
            p,
            {
              gap: 12,
              row: !0,
              align_center: !0,
              space_between: !0,
              className: S(t.text, {
                [t.orange]: v === "orange",
                [t.violet]: v === "violet"
              }),
              children: [
                P,
                o.length > 1 && /* @__PURE__ */ r(p, { gap: 4, row: !0, children: [
                  /* @__PURE__ */ e(
                    L,
                    {
                      iconLeft: "chevron_left",
                      size: "little",
                      color: "violet",
                      onClick: () => _(Math.max(0, i - 1)),
                      disabled: i === 0
                    }
                  ),
                  /* @__PURE__ */ e(
                    L,
                    {
                      iconLeft: "chevron_right",
                      size: "little",
                      color: "violet",
                      onClick: () => _(
                        Math.min(o.length - 1, i + 1)
                      ),
                      disabled: i === o.length - 1
                    }
                  )
                ] })
              ]
            }
          ),
          g === "top" && N
        ]
      }
    );
  }
);
Y.displayName = "PlateImageCurtain";
export {
  Y as PlateImageCurtain
};
